import React from 'react';
import { Calendar } from 'lucide-react';

const PRESETS = [
  { label: '7d', value: '-7d' },
  { label: '14d', value: '-14d' },
  { label: '30d', value: '-30d' },
  { label: '90d', value: '-90d' },
];

const DateRangeSelector = ({ value, onChange }) => {
  return (
    <div className="bi-date-range">
      <Calendar size={14} />
      {PRESETS.map((preset) => (
        <button
          key={preset.value}
          className={`bi-date-btn ${value === preset.value ? 'active' : ''}`}
          onClick={() => onChange(preset.value)}
        >
          {preset.label}
        </button>
      ))}
    </div>
  );
};

export default DateRangeSelector;
